/* FÉNIX R07.63 · PDP zoom trigger. Reutiliza el lightbox existente; no duplica lógica. */
(function(){
  'use strict';
  var initialized=false;

  function init(){
    if(initialized)return;
    var img=document.getElementById('ProductPhotoImg')||document.getElementById('nmMainProductImg');
    if(!img)return;
    if(document.querySelector('.nm-r07-zoom-trigger'))return;

    var host=document.getElementById('ProductPhoto')||img.closest('.product-single__photo')||img.parentElement;
    if(!host)return;

    initialized=true;
    host.classList.add('nm-r07-zoom-host');

    var button=document.createElement('button');
    button.type='button';
    button.className='nm-r07-zoom-trigger';
    button.setAttribute('aria-label','Ampliar imagen del producto');
    button.setAttribute('title','Ampliar imagen');
    button.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.8" cy="10.8" r="6.3" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M15.6 15.6 21 21M10.8 7.7v6.2M7.7 10.8h6.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

    button.addEventListener('click',function(event){
      event.preventDefault();
      event.stopPropagation();
      img.click();
    });

    host.appendChild(button);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
